<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="售前预估信息">
        <div slot="content">
          <edit-data-table
            :head="tableHead"
            :data.sync="tableData"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :border="true"
            :showAdd="showAdd"
             height=""
          >
           <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delBusiessEstimate($index)"></el-button>
              <!-- <el-button icon="el-icon-edit" class="btn" style="color:#4084B7" @click="edit()"></el-button> -->
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="竞争对手信息">
        <div slot="content">
          <edit-data-table
            :head="tableHead2"
            :data.sync="tableData2"
            :config="{trigger: 'click', mode: 'cell'}"
            :editable="true"
            :border="true"
            :showAdd="showAdd"
             height=""
          >
           <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delBusiessCompetitor($index)"></el-button>
              <!-- <el-button icon="el-icon-edit" class="btn" style="color:#4084B7" @click="edit()"></el-button> -->
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="客户信息">
        <div slot="content">
          <edit-data-table
            :head="tableHead3"
            :data.sync="tableData3"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :border="true"
            :showAdd="showAdd"
             height=""
          >
         <template #projectRoles="{row}">
              <span>{{row.projectRoles? row.projectRoles.name:''}}</span>
            </template>
            <template #bsProjectRolesEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRoles"
                 @confirm="(val) => {row.projectRole = val.id}"
              ></data-box>
            </template>
           <template #toolbar="{$index}">
              <el-button type="text" size="mini" icon="el-icon-delete" @click="delBusiessCustomer($index)"></el-button>
              <!-- <el-button icon="el-icon-edit" class="btn" style="color:#4084B7" @click="edit()"></el-button> -->
            </template>
            </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { addBusiess,busiessDetail,delBusiessEstimate,delBusiessCompetitor,delBusiessCustomer } from "@/api/basic";
import { getDocumentCode } from '@/views/utils'

export default {
  components: {
    FoldedPanel,
    DataBox
  },
  data() {
    return {
      showAdd: true,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            disabled: true,
            value: "",
            span: 8
          },
          {
            type: "input",
            key: "businessCode",
            label: "商机号",
            value: "",
            span: 8
          },
          {
            label: "经营人",
            key: "operator",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            key: "owner",
            label: "商机所有人",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            key: "reporter",
            label: "报备人",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            key: "dept",
            label: "所属部门",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "bs-department/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            key: "customer",
            label: "客户",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/customer",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "input",
            key: "demand",
            label: "需求",
            value: "",
            span: 8
          },
          {
            type: "input",
            key: "previewContent",
            label: "预采内容",
            value: "",
            span: 8
          },
          {
            type: "input",
            key: "winName",
            label: "赢单对手",
            value: "",
            span: 8
          },
          {
            type: "select",
            key: "status",
            label: "商机状态",
            value: "",
            span: 8,
            options: [
              {
                value: "0",
                label: "报备"
              },
              {
                value: "1",
                label: "立项"
              },
              {
                value: "2",
                label: "签约"
              },
              {
                value: "3",
                label: "取消"
              },
              {
                value: "4",
                label: "丢单"
              },
              {
                value: "5",
                label: "暂停"
              }
            ]
          },
          {
            type: "input",
            key: "",
            label: "异常状态记录",
            value: "",
            span: 8
          },
          {
            type: "input",
            key: "",
            label: "取消/暂停/丢单说明",
            value: "",
            span: 8
          },
          {
            type: "select",
            key: "stage",
            label: "商机判断",
            value: "",
            span: 8,
            options: [
              {
                value: "0",
                label: "热门商机"
              },
              {
                value: "1",
                label: "赢面大"
              }
            ]
          },
          {
            key: "industry",
            label: "行业",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/industry",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "input",
            key: "source",
            label: "商机来源",
            value: "",
            span: 8
          },
          {
            type: "date",
            key: "forecastSignTime",
            label: "预计签署日期",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd"
          },
          {
            type: "input",
            key: "forecastMoneyTotal",
            label: "预估总金额",
            value: "",
            span: 8
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注",
            span: 16
          },
          {
            type: "textarea",
            key: "busDesc",
            label: "商机描述",
            value: "",
            placeholder: "请输入备注",
            span: 16
          },
          {
            type: "textarea",
            key: "risk",
            label: "项目风险",
            value: "",
            placeholder: "请输入备注",
            span: 16
          },
          {
            type: "upload",
            key: "annexId",
            label: "附件",
            uploadUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
            value: "",
            span: 8,
          },
        ]
      },
      tableHead: [
        {
          label: "项目类型",
          prop: "projectType",
          editRender: { type: "default", name: "ElSelect" ,
           options: [
              {
                value: "0",
                label: "类型一"
              },
              {
                value: "1",
                label: "类型一"
              },
              {
                value: "2",
                label: "类型三"
              }
            ]}
        },
        {
          label: "产品",
          prop: "product",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "预估金额",
          prop: "forecastMoney",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData: [],
       tableData2: [],
        tableData3: [],
      tableHead2: [
        {
          label: "公司名称",
          prop: "companyName",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "对手优势",
          prop: "opponentAdvantage",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead3: [
        {
          label: "关键干系人",
          prop: "cruxPerson",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "部门",
          prop: "deptName",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "职位",
          prop: "position",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default" }
        },
        {
          label: "态度",
          prop: "attitude",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "汇报对象",
          prop: "reportPerson",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      dataBoxHead: [
           { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      obj: {}
    };
  },
   created() {
    this.id = this.$route.query.id;
    if (this.id) {
      busiessDetail(this.id).then(res => {
        const form = res.data.business
        form.operator = { id: form.operator, name: form.operatorName }
        form.owner = { id: form.owner, name: form.ownerName }
        form.reporter = { id: form.reporter, name: form.reporterName }
        form.customer = { id: form.customer, name: form.customerName }
         form.industry = { id: form.industry, name: form.industryName }
        this.form = form
        this.tableData = res.data.saleEstimates;
        this.tableData2 = res.data.competitorsInfos;
        this.tableData3 = res.data.customerInfos;
      });
    } else {
      this.form.code = getDocumentCode('SJ')
      this.form.businessCode = this.form.code
    }
  },
   methods: {
    cancel() {
      this.$router.go(-1);
    },
    // 提交
    submit() {
       if (this.form.operator) {
        this.form.operatorName  = this.form.operator.name
        this.form.operator  = this.form.operator.id
      }
       if (this.form.owner) {
        this.form.ownerName  = this.form.owner.name
        this.form.owner  = this.form.owner.id
      }
       if (this.form.dept) {
        this.form.deptName  = this.form.dept.name
        this.form.dept  = this.form.dept.id
      }
        if (this.form.reporter) {
        this.form.reporterName  = this.form.reporter.name
        this.form.reporter  = this.form.reporter.id
      }
        if (this.form.industry) {
        this.form.industryName  = this.form.industry.name
        this.form.industry  = this.form.industry.id
      }
        if (this.form.customer) {
        this.form.customerName  = this.form.customer.name
        this.form.customer  = this.form.customer.id
      }
      this.obj.business = this.form;
      console.log(this.obj.business);
      this.obj.saleEstimates = this.tableData;
      this.obj.competitorsInfos = this.tableData2;
      this.obj.customerInfos = this.tableData3;
      console.log(this.obj);
      addBusiess(this.obj).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.$notify({
            title: "保存成功",
            type: "success",
            duration: 2500
          });
          this.$router.go(-1);
        }
      });
    },
     delBusiessEstimate(index) {
       if (this.tableData[index].id) {
          delBusiessEstimate(this.tableData[index].id)
           this.tableData.splice(index, 1)
        } else {
          this.tableData.splice(index, 1)
        }
    },
    delBusiessCompetitor(index) {
       if (this.tableData2[index].id) {
          delBusiessCompetitor(this.tableData2[index].id)
           this.tableData2.splice(index, 1)
        } else {
          this.tableData2.splice(index, 1)
        }
    },
    delBusiessCustomer(index) {
       if (this.tableData3[index].id) {
          delBusiessCustomer(this.tableData3[index].id)
           this.tableData3.splice(index, 1)
        } else {
          this.tableData3.splice(index, 1)
        }
    },
   }
};
</script>
<style scoped lang="scss">
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
